export default __webpack_public_path__ + "static/media/verimatrixLogo.57043982.png";